import React from 'react';

// Combined page for the project's utility / admin content. Storage info
// (where the artifacts actually live) followed by the licence terms.
// No headings — just two paragraphs, each clearly distinct.
export default function Notes() {
  return (
    <div>
      <div className="home-container small-width">
        <div className="container">
          <div className="body-text">
            Each artwork is represented as an ERC-721 token on the Ethereum blockchain. The original images and metadata are stored on IPFS, a distributed storage protocol.
          </div>
          <div className="body-text" style={{ marginTop: '16px' }}>
            Unless otherwise stated, all content on this website is &copy; the artist. Each Thing is an original artwork created by the artist. Collectors are granted a non-exclusive, worldwide, non-commercial licence to display, experiment with, adapt, and build upon the artwork for personal, creative, or cultural purposes, and ownership is intended solely for those uses. This licence applies for as long as the collector owns the Thing.
          </div>
        </div>
      </div>
    </div>
  );
}
